import { render, staticRenderFns } from "./ValuesInWidgetInput.vue?vue&type=template&id=4d2175e3&"
import script from "./ValuesInWidgetInput.vue?vue&type=script&lang=js&"
export * from "./ValuesInWidgetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2175e3')) {
      api.createRecord('4d2175e3', component.options)
    } else {
      api.reload('4d2175e3', component.options)
    }
    module.hot.accept("./ValuesInWidgetInput.vue?vue&type=template&id=4d2175e3&", function () {
      api.rerender('4d2175e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/inputs/ValuesInWidgetInput.vue"
export default component.exports